/*
* Created By Jaeuk Ryu <devp011>
*/
import {i18n} from '~/plugins/i18n'

export const state = () => ({
  detailsUrl: '/api/sm/external/signtr',
  // === Table Contents  ===
  detailDataList: [],
  taskNameOptions: []
})

export const mutations = {
  getDetailDataList: (state, data) => { // 상세 정보
    state.detailPopUpData = data.result[0]
    state.detailPopUpData.signtr_server_sched_set = JSON.parse(data.result[0].signtr_server_sched_set)[0]
  },
  getSignatureDetail (state, data) { // 상세 정보
    state.detailDataList = _.cloneDeep(data.result)
    state.taskNameOptions = [{label: i18n.t('cmn.all'), value: -1}]
    state.detailDataList.forEach((item) => {
      state.taskNameOptions.push({label: item.signtr_server_uname, value: item.signtr_server_id})
    })
  },
  getFilterdSignatureDetail (state, data) { // 상세 정보
    state.detailDataList = _.cloneDeep(data.result)
  }
}

export const actions = {
  async getSignatureDetail ({commit, state}) { // 상세 정보
    try {
      const data = await this.$axios.$get(state.detailsUrl)

      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('getSignatureDetail', data)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async getFilterdSignatureDetail ({commit, state}, payload) { // 상세 정보
    try {
      const data = await this.$axios.$get(`${state.url}?signtr_server_id=${payload}`)

      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('getFilterdSignatureDetail', data)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  }
}

export const getters = {}
export const strict = false
